/**
 * Simple debounce helper (no external dependency).
 * @param {Function} fn
 * @param {number} waitMs
 */
export const debounce = (fn, waitMs = 300) => {
  let timeoutId = null;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, waitMs);
  };
};
